import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'chevrons-right', 'IconChevronsRight', [["path",{"d":"M7 7l5 5l-5 5","key":"svg-0"}],["path",{"d":"M13 7l5 5l-5 5","key":"svg-1"}]]);